export default {"src":"/_next/static/media/sucralose.c470431e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};